export function enablePaymentChannelV4(send) {
  return (payeeId, paymentChannelId, ...args) =>
    send(
      {
        path: '/v4/payees/{payeeId}/paymentChannels/{paymentChannelId}/enable',
        pathParameters: { payeeId, paymentChannelId },
        type: 'post',
        query: undefined,
        body: undefined,
        headers: undefined,
        auth: 'oauth2',
        contentType: undefined,
      },
      ...args
    );
}
